import { render, staticRenderFns } from "./InstitutionState.vue?vue&type=template&id=d933b8e0&"
import script from "./InstitutionState.vue?vue&type=script&lang=ts&"
export * from "./InstitutionState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports